import gql from 'graphql-tag';

export default gql`
  mutation updateRepVisitsSettings($input: updateRepVisitsSettingsInput!){
    updateRepVisitsSettings(input: $input){
      heAccount {
        id
        repVisitsSettings {
          optedOutOfRepVisitsRatings
        }
      }
    }
  }
`;
